/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppleOAuthDto } from '../models/AppleOAuthDto';
import type { ConfirmAccountDeletionDto } from '../models/ConfirmAccountDeletionDto';
import type { ConfirmAccountDeletionResponseDto } from '../models/ConfirmAccountDeletionResponseDto';
import type { DeactivateDeviceTokenDto } from '../models/DeactivateDeviceTokenDto';
import type { GetMeResponseDto } from '../models/GetMeResponseDto';
import type { GoogleOAuthDto } from '../models/GoogleOAuthDto';
import type { LinkAppleDto } from '../models/LinkAppleDto';
import type { LinkGoogleDto } from '../models/LinkGoogleDto';
import type { LoginDto } from '../models/LoginDto';
import type { LogoutDto } from '../models/LogoutDto';
import type { ReattachAccountDto } from '../models/ReattachAccountDto';
import type { ReattachAccountResponseDto } from '../models/ReattachAccountResponseDto';
import type { RefreshTokenDto } from '../models/RefreshTokenDto';
import type { RegisterDeviceTokenDto } from '../models/RegisterDeviceTokenDto';
import type { RegisterDto } from '../models/RegisterDto';
import type { RequestAccountDeletionDto } from '../models/RequestAccountDeletionDto';
import type { RequestAccountDeletionResponseDto } from '../models/RequestAccountDeletionResponseDto';
import type { ResendOtpDto } from '../models/ResendOtpDto';
import type { UnlinkProviderDto } from '../models/UnlinkProviderDto';
import type { UpdateProfileDto } from '../models/UpdateProfileDto';
import type { VerifyOtpDto } from '../models/VerifyOtpDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Register a new user
     * Sends an OTP to the provided phone number for registration. Phone number is required, name is optional.
     * @param requestBody
     * @returns any OTP sent successfully
     * @throws ApiError
     */
    public static authControllerRegisterV1(
        requestBody: RegisterDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                409: `Phone number already registered`,
                429: `Too many OTP requests`,
            },
        });
    }
    /**
     * Verify registration OTP
     * Verifies the OTP code and creates the user account. Web clients (device_type=web or unset): access_token in body + both tokens set as httpOnly cookies. refresh_token is NOT in the response body. Mobile clients (device_type=ios/android): both tokens are returned in the response body.
     * @param requestBody
     * @returns any Account created successfully
     * @throws ApiError
     */
    public static authControllerVerifyRegistrationOtpV1(
        requestBody: VerifyOtpDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/register/verify-otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid OTP reference or code`,
                410: `OTP expired or registration session expired`,
                429: `Too many failed attempts — 5-minute lockout enforced, retry after cooldown`,
            },
        });
    }
    /**
     * Initiate login
     * Sends an OTP to the provided registered phone number for login.
     * @param requestBody
     * @returns any OTP sent successfully
     * @throws ApiError
     */
    public static authControllerLoginV1(
        requestBody: LoginDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Account suspended`,
                404: `Phone number not registered`,
                429: `Too many OTP requests`,
            },
        });
    }
    /**
     * Verify login OTP
     * Verifies the OTP sent during login. Web clients (device_type=web or unset): access_token in body + both tokens set as httpOnly cookies. refresh_token is NOT in the response body. Mobile clients (device_type=ios/android): both tokens are returned in the response body.
     * @param requestBody
     * @returns any Successfully logged in
     * @throws ApiError
     */
    public static authControllerVerifyLoginOtpV1(
        requestBody: VerifyOtpDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/login/verify-otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid OTP reference or code`,
                410: `OTP expired or login session expired`,
                429: `Too many failed attempts — 5-minute lockout enforced, retry after cooldown`,
            },
        });
    }
    /**
     * Resend OTP
     * Resends the OTP code. Respects 60-second cooldown and max 3 resend attempts.
     * @param requestBody
     * @returns any OTP resent successfully
     * @throws ApiError
     */
    public static authControllerResendOtpV1(
        requestBody: ResendOtpDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/resend-otp',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid OTP reference or cooldown active`,
                429: `Please wait before requesting a new code`,
            },
        });
    }
    /**
     * Logout
     * Ends the current session. Revokes the refresh token and clears cookies. The refresh token can be provided via HTTP-only cookie (default) or in the request body (for Swagger/mobile).
     * @param requestBody
     * @returns any Successfully logged out
     * @throws ApiError
     */
    public static authControllerLogoutV1(
        requestBody: LogoutDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/logout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Refresh access token
     * Issues a new access token using a valid refresh token. The refresh token can be provided via HTTP-only cookie (default) or in the request body (for Swagger/mobile).
     * @param requestBody
     * @returns any Token refreshed
     * @throws ApiError
     */
    public static authControllerRefreshTokenV1(
        requestBody: RefreshTokenDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/refresh-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid or expired refresh token`,
            },
        });
    }
    /**
     * Get current user profile
     * Returns the authenticated user's profile information, including suspension details and onboarding progress.
     * @returns GetMeResponseDto User profile retrieved
     * @throws ApiError
     */
    public static authControllerGetMeV1(): CancelablePromise<GetMeResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/auth/me',
            errors: {
                401: `Unauthorized`,
                403: `Account has been deleted`,
                404: `User not found`,
            },
        });
    }
    /**
     * Update user profile
     * Updates the authenticated user's profile. Only provided fields are updated.
     * @param requestBody
     * @returns any Changes have been saved
     * @throws ApiError
     */
    public static authControllerUpdateProfileV1(
        requestBody: UpdateProfileDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/auth/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                404: `User not found`,
                409: `Email or phone number already in use`,
            },
        });
    }
    /**
     * Google OAuth Sign-In
     * Authenticate or register a user using Google Sign-In. Accepts a Google ID token from the client. Optional fields: device_type, device_token, and device_name. When device_token is provided, backend upserts user_devices and links the issued refresh token to that device. If the user exists, logs them in. If not, creates a new account. Web clients (device_type=web or unset): access_token in body + both tokens set as httpOnly cookies, refresh_token not returned in body. Mobile clients (device_type=ios/android): both tokens are returned in the response body.
     * @param requestBody
     * @returns any Successfully authenticated with Google
     * @throws ApiError
     */
    public static authControllerGoogleOAuthV1(
        requestBody: GoogleOAuthDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/google',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid Google token or missing email`,
                401: `Failed to authenticate with Google`,
                403: `Account suspended`,
            },
        });
    }
    /**
     * Apple OAuth Sign-In
     * Authenticate or register a user using Sign in with Apple. Accepts an Apple identity token (JWT) from the client. full_name is only available on the first Apple sign-in and must be sent by the client when available. If the user exists, logs them in. If not, creates a new account. Web clients (device_type=web or unset): access_token in body + both tokens set as httpOnly cookies. Mobile clients (device_type=ios/android): both tokens are returned in the response body.
     * @param requestBody
     * @returns any Successfully authenticated with Apple
     * @throws ApiError
     */
    public static authControllerAppleOAuthV1(
        requestBody: AppleOAuthDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/apple',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid Apple token or missing user ID`,
                401: `Failed to authenticate with Apple`,
                403: `Account suspended`,
            },
        });
    }
    /**
     * Link Google account
     * Links a Google account to the authenticated user. Requires a Google ID token from Google Sign-In. Fails with 409 if the Google account is already linked to another user.
     * @param requestBody
     * @returns any Google account linked successfully
     * @throws ApiError
     */
    public static authControllerLinkGoogleV1(
        requestBody: LinkGoogleDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/link/google',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized or invalid Google token`,
                409: `Google account already linked to another user`,
            },
        });
    }
    /**
     * Link Apple account
     * Links an Apple account to the authenticated user. Requires an Apple identity token from Sign in with Apple. Fails with 409 if the Apple account is already linked to another user.
     * @param requestBody
     * @returns any Apple account linked successfully
     * @throws ApiError
     */
    public static authControllerLinkAppleV1(
        requestBody: LinkAppleDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/link/apple',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized or invalid Apple token`,
                409: `Apple account already linked to another user`,
            },
        });
    }
    /**
     * Redeem a handover ticket after signing in by phone
     * Moves a duplicate signup's Google/Apple identity onto this account and retires the duplicate. Called once, straight after phone OTP sign-in, with the ticket minted by POST /v1/onboarding/handover-ticket. Authorised by the caller's own verified phone matching the one the ticket was minted against, so a ticket can only ever be redeemed by the account that owns that number. Not interchangeable with /auth/link/google — that endpoint rejects a provider email that differs from the account email, which is exactly the case this exists for.
     * @param requestBody
     * @returns ReattachAccountResponseDto Identity reattached
     * @throws ApiError
     */
    public static authControllerReattachAccountV1(
        requestBody: ReattachAccountDto,
    ): CancelablePromise<ReattachAccountResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/reattach',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed`,
                401: `Unauthorized`,
                403: `Ticket does not belong to the signed-in account`,
                404: `User not found`,
                409: `Target already linked to a different provider account`,
                410: `Ticket expired or already used`,
                425: `Another redemption of this ticket is in flight. Transient — retry, and do NOT discard the ticket (unlike the terminal 403/409/410)`,
            },
        });
    }
    /**
     * Unlink social account
     * Disconnects a social account (Google or Apple) from the authenticated user. The user can still log in via phone. If the unlinked provider was the primary auth_provider, it resets to phone.
     * @param requestBody
     * @returns any Social account unlinked successfully
     * @throws ApiError
     */
    public static authControllerUnlinkProviderV1(
        requestBody: UnlinkProviderDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/unlink',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Provider not linked or validation failed`,
                401: `Unauthorized`,
                404: `User not found`,
            },
        });
    }
    /**
     * Request account deletion OTP
     * Sends an OTP to the user's registered phone number to confirm account deletion. Rate-limited. Requires authentication.
     * @param requestBody
     * @returns RequestAccountDeletionResponseDto OTP sent successfully
     * @throws ApiError
     */
    public static authControllerRequestAccountDeletionV1(
        requestBody: RequestAccountDeletionDto,
    ): CancelablePromise<RequestAccountDeletionResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/account-delete/request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Account already deleted or phone number missing`,
                401: `Unauthorized`,
                429: `Too many OTP requests`,
            },
        });
    }
    /**
     * Confirm account deletion
     * Verifies the OTP and performs soft delete. Sets deleted_at, deletion_grace_ends_at (30 days), status=deleted. Revokes all refresh tokens and deletes device tokens. User cannot log in after confirmation.
     * @param requestBody
     * @returns ConfirmAccountDeletionResponseDto Account deleted successfully
     * @throws ApiError
     */
    public static authControllerConfirmAccountDeletionV1(
        requestBody: ConfirmAccountDeletionDto,
    ): CancelablePromise<ConfirmAccountDeletionResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/auth/account-delete/confirm',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid OTP or OTP already used`,
                401: `Unauthorized`,
                403: `OTP does not belong to this user`,
                410: `OTP or deletion session expired`,
                429: `Too many failed attempts`,
            },
        });
    }
    /**
     * Register or update a push notification device token
     * Upserts the device token for the authenticated user. Call this after obtaining notification permissions post-login.
     * @param requestBody
     * @returns any Device token registered
     * @throws ApiError
     */
    public static authControllerRegisterDeviceTokenV1(
        requestBody: RegisterDeviceTokenDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/auth/device-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                429: `Too many requests`,
            },
        });
    }
    /**
     * Deactivate a push notification device token (no auth required)
     * Marks the device token as inactive so no further push notifications are sent to it. Intended as a fallback when the authenticated logout flow cannot run (e.g. session expired). Possession of the push token is treated as sufficient authorization.
     * @param requestBody
     * @returns any Device token deactivated
     * @throws ApiError
     */
    public static authControllerDeactivateDeviceTokenV1(
        requestBody: DeactivateDeviceTokenDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/auth/device-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                429: `Too many requests`,
            },
        });
    }
}
